import React from "react";
import { FileText, BookOpen, File, Percent, CreditCard, BarChart2 } from "react-feather";
import { useHistory } from "react-router-dom";

const AccountingManagement = () => {
  const history = useHistory();
  
  const cards = [
    { name: "Commissions", icon: <FileText size={42} className="text-primary" />, link: "/dashboard/Accounting/Commission" },
    // { name: "Policies", icon: <BookOpen size={42} className="text-primary" />, link: "/dashboard/accounting/Policies" },
    // { name: "Invoices", icon: <File size={42} className="text-primary" />, link: "/dashboard/accounting/Invoices" },
    // { name: "Taxes", icon: <Percent size={42} className="text-primary" />, link: "/dashboard/accounting/Taxes" },
    { name: "Wallet", icon: <CreditCard size={42} className="text-primary" />, link: "/dashboard/accounting/Wallet" },

  ];

  return (
    <div className="min-vh-100" style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"1rem"}
      }>
      <div className="container-fluid px-4 py-5">
        <div className="mb-5">
          <h2 className="fw-bold fs-1 text-dark mb-2">
            Accounting Management
          </h2>
          <p className="text-muted fs-6 mb-0">
            Manage all your accounting operations from one central location
          </p>
        </div>
        
        <div className="row g-0">
          {cards.map((card, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4 p-3">
              <div
                className="card border-0 shadow-sm h-100 card-hover"
                style={{ 
                  borderRadius: "16px", 
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  minHeight: "220px"
                }}
                onClick={() => history.push(card.link)}
              >
                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                  <div 
                    className="mb-4 d-flex align-items-center justify-content-center"
                    style={{ 
                      width: "80px", 
                      height: "80px", 
                      borderRadius: "50%", 
                      backgroundColor: "rgba(13, 110, 253, 0.1)" 
                    }}
                  >
                    {card.icon}
                  </div>
                  
                  <h5 className="card-title fw-semibold text-dark mb-3 fs-5">
                    {card.name}
                  </h5>
                  
                  <p className="card-text text-muted small mb-0 lh-base">
                    Manage your {card.name.toLowerCase()} efficiently and track performance
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountingManagement;